import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toFormData',
})
export class FormDataPipe implements PipeTransform {
  transform(file: File, fieldName = 'file'): FormData {
    if (!file) {
      return new FormData();
    }

    const formData = new FormData();
    formData.append(fieldName, file);
    return formData;
  }
}
